import { resetBarcodeModalInfo } from '@actions/barcode'
import { useActions } from '@hooks/useActions'
import { useNavigationFlowHandler } from '@hooks/useNavigationFlowHandler'
import { default as React, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { BarcodeScanModalExactUpc } from './Modals/BarcodeScanModalExactUpc'
import { BarcodeScanModalOnlyCustom } from './Modals/BarcodeScanModalOnlyCustom'
import { BarcodeScanModalOtherPolarizedMoco } from './Modals/BarcodeScanModalOtherPolarizedMoco'
import { BarcodeScanModalOtherPRIZMMoco } from './Modals/BarcodeScanModalOtherPRIZMMoco'
import { BarcodeScanModalSameModel } from './Modals/BarcodeScanModalSameModel'
import { BarcodeScanModalUnavailablePolarized } from './Modals/BarcodeScanModalUnavailablePolarized'
import { BarcodeScanModalUnavailablePolarizedSameMoco } from './Modals/BarcodeScanModalUnavailablePolarizedSameMoco'
import { BarcodeScanModalUnavailablePRIZMMoco } from './Modals/BarcodeScanModalUnavailablePRIZMMoco'
import { BarcodeScanModalWithRedirectProps } from './types'

const BarCodeScanModal: React.FC = () => {
  const { productInfo, scenario } = useSelector(s => s.barcode)
  const { barcodeFlow } = useNavigationFlowHandler()
  const history = useHistory()

  const actions = useActions({ resetBarcodeModalInfo })
  const [visible, setVisible] = useState(barcodeFlow)

  const handleCloseModal = () => {
    setVisible(false)
    actions.resetBarcodeModalInfo()
  }

  const onRedirect = (url: string) => {
    history.replace(history.location.pathname)
    history.push(url)
    handleCloseModal()
  }

  const renderModal = () => {
    const modalProps = {
      visible,
      productInfo,
      onCancel: handleCloseModal,
      onRedirect,
    } as BarcodeScanModalWithRedirectProps
    // TODO: consider shared modals for same scenario style? (eg. close-modal cta-only, two cta with redirect, etc.)
    switch (scenario) {
      case 'scenario1':
        return <BarcodeScanModalExactUpc {...modalProps} />
      case 'scenario2B':
      case 'scenario2C':
        return <BarcodeScanModalOtherPRIZMMoco {...modalProps} />
      case 'scenario3B':
        return <BarcodeScanModalOtherPolarizedMoco {...modalProps} />
      case 'scenario4A':
        return <BarcodeScanModalSameModel {...modalProps} />
      case 'scenario4B':
        return <BarcodeScanModalOnlyCustom {...modalProps} />
      case 'scenario5A':
      case 'scenario5B':
        return <BarcodeScanModalUnavailablePRIZMMoco {...modalProps} />
      case 'scenario6':
        return <BarcodeScanModalUnavailablePolarized {...modalProps} />
      case 'scenario7':
        return <BarcodeScanModalUnavailablePolarizedSameMoco {...modalProps} />
      default:
        return null
    }
  }

  return <>{renderModal()}</>
}

export default BarCodeScanModal
